// Generated by Melange

import PlayerToolbarModuleCss from "./playerToolbar.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Shared__Button from "./button.jsx";
import * as Shared__Gain from "./gain.jsx";
import * as Shared__H2 from "./h2.jsx";
import * as Shared__Label from "./label.jsx";
import * as Shared__Popover from "./popover.jsx";
import * as Shared__QueueContext from "./queueContext.jsx";
import * as Shared__RadioGroup from "./radioGroup.jsx";
import * as Shared__Slider from "./slider.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__GoToNextSong from "../storeFx/goToNextSong.jsx";
import * as StoreFx__GoToPrevSong from "../storeFx/goToPrevSong.jsx";
import * as StoreFx__HandleMediaSessionAction from "../storeFx/handleMediaSessionAction.jsx";
import * as StoreFx__Run from "../storeFx/run.jsx";
import * as StoreFx__RunAsync from "../storeFx/runAsync.jsx";
import * as StoreFx__SetCurrentTime from "../storeFx/setCurrentTime.jsx";
import * as StoreFx__SetReplayGainOptions from "../storeFx/setReplayGainOptions.jsx";
import * as StoreFx__SetVolume from "../storeFx/setVolume.jsx";
import * as StoreFx__SubscribeToAudioEvents from "../storeFx/subscribeToAudioEvents.jsx";
import * as StoreFx__ToggleMuted from "../storeFx/toggleMuted.jsx";
import * as StoreFx__TogglePaused from "../storeFx/togglePaused.jsx";
import * as Store__Context from "../store/context.jsx";
import * as Store__State from "../store/state.jsx";
import * as Webapi__Dom__Document from "melange-webapi/Webapi/Dom/Webapi__Dom__Document.jsx";
import * as Webapi__Dom__Element from "melange-webapi/Webapi/Dom/Webapi__Dom__Element.jsx";
import Clsx from "clsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = PlayerToolbarModuleCss;

function PlayerToolbar(Props) {
  let queueId = Props.queueId;
  let queueTriggerRef = Props.queueTriggerRef;
  const runStoreFx = StoreFx__Run.use(undefined);
  React.useEffect((function () {
    return Stdlib__Option.some(Stdlib__Result.get_ok(Curry._1(runStoreFx, StoreFx__SubscribeToAudioEvents.make(undefined))));
  }), [runStoreFx]);
  const runStoreFx$1 = StoreFx__Run.use(undefined);
  const runAsyncStoreFx = StoreFx__RunAsync.use(undefined);
  React.useEffect((function () {
    const abortController = new AbortController();
    window.addEventListener("keydown", (function ($$event) {
      const $$document$1 = Stdlib__Option.get(Webapi__Dom__Document.asHtmlDocument(document));
      const activeElement = Stdlib__Option.get(Caml_option.nullable_to_opt($$document$1.activeElement));
      const body = Stdlib__Option.get(Caml_option.nullable_to_opt($$document$1.body));
      const code = $$event.code;
      if (activeElement === body) {
        let exit = 0;
        switch (code) {
          case "ArrowDown" :
            $$event.preventDefault();
            Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__SetVolume.make(function (param) {
              return Stdlib__Fun.flip((function (prim0, prim1) {
                return prim0 - prim1;
              }), 0.05, param);
            })));
            return;
          case "ArrowUp" :
            $$event.preventDefault();
            Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__SetVolume.make(function (param) {
              return Stdlib__Fun.flip((function (prim0, prim1) {
                return prim0 + prim1;
              }), 0.05, param);
            })));
            return;
          case "ArrowLeft" :
          case "KeyJ" :
            exit = 2;
            break;
          case "ArrowRight" :
          case "KeyL" :
            exit = 3;
            break;
          case "KeyK" :
          case "Space" :
            exit = 1;
            break;
          default:
            return;
        }
        switch (exit) {
          case 1 :
            $$event.preventDefault();
            Curry._1(runAsyncStoreFx, StoreFx__TogglePaused.make(undefined)).then(function (result) {
              return Promise.resolve(Stdlib__Result.get_ok(result));
            });
            return;
          case 2 :
            Curry._1(runAsyncStoreFx, StoreFx__SetCurrentTime.make(function (param) {
              return Stdlib__Fun.flip((function (prim0, prim1) {
                return prim0 - prim1;
              }), 10.0, param);
            })).then(function (result) {
              return Promise.resolve(Stdlib__Result.get_ok(result));
            });
            return;
          case 3 :
            Curry._1(runAsyncStoreFx, StoreFx__SetCurrentTime.make(function (param) {
              return Stdlib__Fun.flip((function (prim0, prim1) {
                return prim0 + prim1;
              }), 10.0, param);
            })).then(function (result) {
              return Promise.resolve(Stdlib__Result.get_ok(result));
            });
            return;
        }
      } else {
        if (code !== "Escape") {
          return;
        }
        const activeElement$1 = Webapi__Dom__Element.asHtmlElement(activeElement);
        if (activeElement$1 !== undefined) {
          Caml_option.valFromOption(activeElement$1).blur();
          return;
        } else {
          return;
        }
      }
    }), {
      capture: false,
      passive: false,
      signal: abortController.signal
    });
    return (function (param) {
      abortController.abort();
    });
  }), [
    runAsyncStoreFx,
    runStoreFx$1
  ]);
  React.useEffect((function () {
    const actions = [
      "nexttrack",
      "pause",
      "play",
      "previoustrack",
      "seekbackward",
      "seekforward",
      "seekto",
      "stop"
    ];
    const arg = (function ($$event) {
      Curry._1(runAsyncStoreFx, StoreFx__HandleMediaSessionAction.make($$event)).then(function (result) {
        return Promise.resolve(Stdlib__Result.get_ok(result));
      });
    });
    actions.forEach(function (param) {
      navigator.mediaSession.setActionHandler(param, arg);
    });
    return (function (param) {
      actions.forEach(function (param) {
        navigator.mediaSession.setActionHandler(param, undefined);
      });
    });
  }), [runAsyncStoreFx]);
  const match = React.useState(function () {
    
  });
  const setRepeatMode = match[1];
  const repeatMode = match[0];
  let tmp;
  tmp = repeatMode !== undefined && repeatMode !== /* RepeatAll */ 0 ? "Repeat one" : "Repeat all";
  let tmp$1;
  let exit = 0;
  if (repeatMode !== undefined && repeatMode !== /* RepeatAll */ 0) {
    tmp$1 = JsxRuntime.jsx(LucideReact$1.Repeat1, Curry._4(LucideReact.Repeat1.makeProps, undefined, undefined, "none", undefined));
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(LucideReact$1.Repeat, Curry._4(LucideReact.Repeat.makeProps, undefined, undefined, "none", undefined));
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Shared__Popover.Root.make, {
          children: [
            JsxRuntime.jsx(Shared__Popover.Content.make, {
              children: React.cloneElement(JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Shared__H2.make, {
                    children: "Volume",
                    id: "volume-heading"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Store__Context.Consumer.make, {
                            children: (function (volume) {
                              return JsxRuntime.jsx(Shared__Slider.make, {
                                ariaLabelledby: "volume-heading",
                                max: 1.0,
                                step: 0.05,
                                value: volume,
                                onValueChange: (function (newVolume) {
                                  Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__SetVolume.make(function (param) {
                                    return Stdlib__Fun.$$const(newVolume, param);
                                  })));
                                })
                              });
                            }),
                            selector: (function (state) {
                              return state.player.volume;
                            })
                          }),
                          JsxRuntime.jsx(Store__Context.Consumer.make, {
                            children: (function (state) {
                              return JsxRuntime.jsx(Shared__Button.make, {
                                ariaLabel: "Mute",
                                ariaPressed: state === "muted" ? "true" : "false",
                                children: state === "volume2" ? JsxRuntime.jsx(LucideReact$1.Volume2, Curry._4(LucideReact.Volume2.makeProps, undefined, undefined, "none", undefined)) : (
                                    state === "muted" ? JsxRuntime.jsx(LucideReact$1.VolumeX, Curry._4(LucideReact.VolumeX.makeProps, undefined, undefined, "none", undefined)) : JsxRuntime.jsx(LucideReact$1.Volume1, Curry._4(LucideReact.Volume1.makeProps, undefined, undefined, "none", undefined))
                                  ),
                                variant: "icon",
                                onClick: (function (param) {
                                  Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__ToggleMuted.make(undefined)));
                                })
                              });
                            }),
                            selector: (function (state) {
                              if (state.player.muted || state.player.volume === 0.0) {
                                return "muted";
                              } else if (state.player.volume < 0.5) {
                                return "volume1";
                              } else {
                                return "volume2";
                              }
                            })
                          })
                        ],
                        className: css.volumeSettingsItem
                      }),
                      JsxRuntime.jsx(Store__Context.Consumer.make, {
                        children: (function (preferredGain) {
                          return JsxRuntime.jsxs(Shared__RadioGroup.Root.make, {
                            children: [
                              JsxRuntime.jsx(Shared__RadioGroup.Label.make, {
                                children: "Normalization"
                              }),
                              JsxRuntime.jsx(Shared__RadioGroup.Item.make, {
                                label: "None",
                                value: ""
                              }),
                              JsxRuntime.jsx(Shared__RadioGroup.Item.make, {
                                label: "Album",
                                value: "album"
                              }),
                              JsxRuntime.jsx(Shared__RadioGroup.Item.make, {
                                label: "Track",
                                value: "track"
                              })
                            ],
                            name: "replay-gain",
                            value: Stdlib__Option.value(Stdlib__Option.map(Store__State.ReplayGainOptions.stringOfPreferredGain, preferredGain), ""),
                            onValueChange: (function (newValue) {
                              Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__SetReplayGainOptions.make(function (prevOptions) {
                                return {
                                  preAmp: prevOptions.preAmp,
                                  preferredGain: Store__State.ReplayGainOptions.preferredGainOfString(newValue)
                                };
                              })));
                            })
                          });
                        }),
                        selector: (function (state) {
                          return state.player.replayGainOptions.preferredGain;
                        })
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Shared__Label.make, {
                            children: "Pre-amp",
                            className: css.volumeSettingsPreAmpLabel,
                            htmlFor: "pre-amp"
                          }),
                          JsxRuntime.jsx(Store__Context.Consumer.make, {
                            children: (function (preAmp) {
                              return JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx(Shared__Slider.make, {
                                    id: "pre-amp",
                                    markers: [
                                      -15.0,
                                      -10.0,
                                      -5.0,
                                      0.0,
                                      5.0,
                                      10.0,
                                      15.0
                                    ].map(function (value) {
                                      return {
                                        label: Shared__Gain.format(value),
                                        value: value
                                      };
                                    }),
                                    max: 15.0,
                                    min: -15.0,
                                    step: 0.5,
                                    value: preAmp,
                                    onValueChange: (function (newPreAmp) {
                                      Stdlib__Result.get_ok(Curry._1(runStoreFx$1, StoreFx__SetReplayGainOptions.make(function (prevOptions) {
                                        return {
                                          preAmp: newPreAmp,
                                          preferredGain: prevOptions.preferredGain
                                        };
                                      })));
                                    })
                                  }),
                                  JsxRuntime.jsxs("span", {
                                    children: [
                                      Shared__Gain.format(preAmp),
                                      " dB"
                                    ],
                                    className: css.volumeSettingsPreAmpUnits
                                  })
                                ]
                              });
                            }),
                            selector: (function (state) {
                              return state.player.replayGainOptions.preAmp;
                            })
                          })
                        ],
                        className: css.volumeSettingsItem
                      })
                    ],
                    className: css.volumeSettingsContent
                  })
                ],
                className: css.volumeSettings,
                id: "volume-settings"
              }), {
                popover: "auto"
              }),
              padding: 4.0,
              placement: "topEnd",
              strategy: "fixed"
            }),
            JsxRuntime.jsx(Shared__Popover.Reference.make, {
              children: JsxRuntime.jsx(Shared__Button.make, {
                ariaLabel: "Volume",
                children: JsxRuntime.jsx(LucideReact$1.SlidersVertical, Curry._4(LucideReact.SlidersVertical.makeProps, undefined, undefined, "none", undefined)),
                className: Clsx(css.btn, css.volumeSettingsTrigger),
                popovertarget: "volume-settings",
                variant: "icon"
              })
            })
          ]
        }),
        className: css.item
      }),
      JsxRuntime.jsx(Store__Context.Consumer.make, {
        children: (function (queuedSongCount) {
          return JsxRuntime.jsx(Shared__Button.make, {
            ariaLabel: "Previous song",
            children: JsxRuntime.jsx(LucideReact$1.SkipBack, Curry._4(LucideReact.SkipBack.makeProps, undefined, undefined, "none", undefined)),
            className: Clsx(css.item, css.btn),
            disabled: queuedSongCount === 0,
            variant: "icon",
            onClick: (function (param) {
              Curry._1(runAsyncStoreFx, StoreFx__GoToPrevSong.make(undefined)).then(function (result) {
                return Promise.resolve(Stdlib__Result.get_ok(result));
              });
            })
          });
        }),
        selector: (function (state) {
          return state.player.queuedSongIds.length;
        })
      }),
      JsxRuntime.jsx(Store__Context.Consumer.make, {
        children: (function (hasCurrentSong) {
          return JsxRuntime.jsx(Store__Context.Consumer.make, {
            children: (function (paused) {
              return JsxRuntime.jsx(Shared__Button.make, {
                ariaLabel: paused ? "Play" : "Pause",
                children: paused ? JsxRuntime.jsx(LucideReact$1.Play, Curry._4(LucideReact.Play.makeProps, undefined, undefined, "none", undefined)) : JsxRuntime.jsx(LucideReact$1.Pause, Curry._4(LucideReact.Pause.makeProps, undefined, undefined, "none", undefined)),
                className: Clsx(css.item, css.btn),
                disabled: !hasCurrentSong,
                variant: "icon",
                onClick: (function (param) {
                  Curry._1(runAsyncStoreFx, StoreFx__TogglePaused.make(undefined)).then(function (result) {
                    return Promise.resolve(Stdlib__Result.get_ok(result));
                  });
                })
              });
            }),
            selector: (function (state) {
              return state.player.paused;
            })
          });
        }),
        selector: (function (state) {
          return Stdlib__Option.is_some(state.player.currentSongId);
        })
      }),
      JsxRuntime.jsx(Store__Context.Consumer.make, {
        children: (function (queuedSongCount) {
          return JsxRuntime.jsx(Shared__Button.make, {
            ariaLabel: "Next song",
            children: JsxRuntime.jsx(LucideReact$1.SkipForward, Curry._4(LucideReact.SkipForward.makeProps, undefined, undefined, "none", undefined)),
            className: Clsx(css.item, css.btn),
            disabled: queuedSongCount === 0,
            variant: "icon",
            onClick: (function (param) {
              Curry._1(runAsyncStoreFx, StoreFx__GoToNextSong.make(undefined)).then(function (result) {
                return Promise.resolve(Stdlib__Result.get_ok(result));
              });
            })
          });
        }),
        selector: (function (state) {
          return state.player.queuedSongIds.length;
        })
      }),
      JsxRuntime.jsx(Shared__QueueContext.Consumer.make, {
        children: (function (param) {
          const setIsOpen = param.setIsOpen;
          const isOpen = param.isOpen;
          return JsxRuntime.jsx(Shared__Button.make, {
            ariaControls: queueId,
            ariaExpanded: isOpen,
            ariaLabel: "Now playing queue",
            children: JsxRuntime.jsx(LucideReact$1.ListMusic, Curry._4(LucideReact.ListMusic.makeProps, undefined, undefined, "none", undefined)),
            className: Clsx(Clsx(css.item, css.btn), isOpen ? css.queueButtonIsOpen : undefined),
            variant: "icon",
            onClick: (function (param) {
              Curry._1(setIsOpen, (function (prevState) {
                return !prevState;
              }));
            }),
            ref: queueTriggerRef
          });
        })
      }),
      JsxRuntime.jsx(Shared__Button.make, {
        ariaLabel: tmp,
        ariaPressed: repeatMode !== undefined ? "true" : "false",
        children: tmp$1,
        className: Clsx(Clsx(css.item, css.btn), Stdlib__Option.is_some(repeatMode) ? css.repeatEnabled : undefined),
        variant: "icon",
        onClick: (function (param) {
          Curry._1(setRepeatMode, (function (param) {
            if (param !== undefined) {
              if (param === /* RepeatAll */ 0) {
                return /* RepeatOne */ 1;
              } else {
                return;
              }
            } else {
              return /* RepeatAll */ 0;
            }
          }));
        })
      })
    ],
    className: css.root
  });
}

const make = PlayerToolbar;

export {
  make,
}
/* css Not a pure module */
